import { render, staticRenderFns } from "./style6.vue?vue&type=template&id=65506d52&scoped=true"
import script from "./style6.vue?vue&type=script&lang=js"
export * from "./style6.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65506d52",
  null
  
)

export default component.exports